import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { heroiconsWarning } from '@ld.consumer-portal/data-uri';
import { UserIdleService } from '@ld.consumer-portal/utils';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-session-timeout-modal',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './session-timeout-modal.component.html',
  styleUrl: './session-timeout-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionTimeoutModalComponent {
  protected readonly heroiconsWarning = heroiconsWarning;
  protected readonly userIdleService = inject(UserIdleService);
  private readonly dialog = inject(Dialog);

  isOpen = input<boolean>(false);

  protected readonly showWarning = computed(() => this.isOpen() || this.userIdleService.showWarning());

  protected readonly countDown = this.userIdleService.countDown;

  protected readonly countDownFormatted = this.userIdleService.countDownFormatted;

  protected readonly isRefreshing = signal(false);

  private readonly dismissOverlayDialogsEffect = effect(() => {
    if (this.showWarning()) {
      this.dialog.closeAll();
    }
  });

  protected async onContinueSession(): Promise<void> {
    if (this.isRefreshing()) {
      return;
    }

    this.isRefreshing.set(true);
    try {
      await this.userIdleService.continueSession();
    } finally {
      this.isRefreshing.set(false);
    }
  }

  protected onLogoutNow(): void {
    this.userIdleService.logoutDueToInactivity();
  }
}
